// Manual mapping for runtime OpenAPI response validation.
// Update this whenever the generated RTK endpoint names or OpenAPI operations change.
import {
    get_GetTransportOrder,
    get_GetTransportOrderRoute,
    get_ListCurrentTransportOrders,
    get_ListEligibleTransportOrderVehicles,
    get_ListTransportOrders,
    patch_UpdateTransportOrder,
    post_CancelTransportOrder,
    post_CreateTransportOrder,
} from './generated/transportOrders.zod';

export const transportOrdersEndpointSchemas = {
    listCurrentTransportOrders: get_ListCurrentTransportOrders,
    // Same operation, called with the status filter the document does not describe yet.
    // See src/api/currentTransportOrdersByStatus.ts.
    listCurrentTransportOrdersByStatus: get_ListCurrentTransportOrders,
    listTransportOrders: get_ListTransportOrders,
    createTransportOrder: post_CreateTransportOrder,
    listEligibleTransportOrderVehicles: get_ListEligibleTransportOrderVehicles,
    getTransportOrder: get_GetTransportOrder,
    updateTransportOrder: patch_UpdateTransportOrder,
    cancelTransportOrder: post_CancelTransportOrder,
    getTransportOrderRoute: get_GetTransportOrderRoute,
} as const;
